import _ from 'lodash';

const LIVEPREVIEW_BLACK_LIST_ACTIONS = new Set();
const setStageUnfriendlyFunctions = (clz, methodNames) => {
    if (!methodNames) {
        return;
    }
    const nameArr = _.isArray(methodNames) ? methodNames : [methodNames];
    return _.forEach(nameArr, methodName => {
        const method = _.get(clz, `prototype.${methodName}`);
        LIVEPREVIEW_BLACK_LIST_ACTIONS.add(method);
    });
};

function isStageUnfriendly(method) {
    return LIVEPREVIEW_BLACK_LIST_ACTIONS.has(method);
}

function setShouldClearState(val) {
    self.shouldClearState = val;
}

function getShouldClearState() {
    return self.shouldClearState;
}


export {
    setStageUnfriendlyFunctions,
    isStageUnfriendly,
    setShouldClearState,
    getShouldClearState
};

